import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';

let middlewares = applyMiddleware(
    thunkMiddleware,
);
if (process.env.NODE_ENV === 'development') {
    middlewares = composeWithDevTools(middlewares);
}

export const store = createStore(
    rootReducer,
    middlewares
);

export default store;